import customercreditFullcont  from "./customercredit-fullcont.html";

const dialog          = require ('../../../../../components/dialog/dialog')
const fullcontEntity  = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require ('../../../../../components/fullcont/fullcont-handler')
const customercreditDt      = require('./customercredit-dt')
const customercreditMenu    = require('./customercredit-menu')
const handler         = require('./customercredit-fullcont-handler')
const {formCopy}      = require('./customercredit-fullcont-form') 
const {form}          = require('./customercredit-fullcont-form')
const {customercreditMT} = require('./customercredit-fullcont-multitable')
const timeDate = require ('../../../../../js-handler/time-date')

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(

            'customercredit', //database table name****
            'customercredit', //dest entity on js
            'customercredit-fullcont', 
             customercreditFullcont, form, formCopy, customercreditMT, 
             editDialog, deleteDialog, dtCall, htmlFc)

	HTMLwasSelected   = true  

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail){  
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne:                { start: (detail)=>{  addOne(detail, htmlFc)                                    }},
      cancelEdit:            { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                 }},
      deleteEntity:          { start: (detail)=>{  fullcontEntity.deleteEntity(detail, htmlFc)               }},
      deleteFromDialog:      { start: (detail)=>{  deleteFromDialog(detail, htmlFc)                          }},
      discard:               { start: (detail)=>{  fullcontHandler.discard(detail, htmlFc)                   }},
      fullcontOptions:       { start: (detail)=>{  customercreditMenu.start(detail, 'htmlDt', htmlFc )       }},
      hide:                  { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                       }},
      prepareAdd:            { start: (detail)=>{  fullcontEntity.prepareAdd(detail, htmlFc, setDefaultValue)}},
      prepareEdit:           { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)               }},
      saveFromDialog:        { start: (detail)=>{  saveFromDialog(detail, htmlFc)                            }},
      selectOne:             { start: (detail)=>{  fullcontEntity.selectOne(detail, htmlFc)                  }},
      selectOneNoCheck:      { start: (detail)=>{  fullcontEntity.selectOneNoCheck(detail, htmlFc)           }},
      update:                { start: (detail)=>{  update(detail, htmlFc)                                    }},
      getAllInvoiceCredited: { start: (detail)=>{  handler.getAllInvoiceCredited(detail, htmlFc)             }},
      keyValueCredited:      { start: (detail)=>{  handler.keyValueCredited(detail, htmlFc)                  }},
      keyValueSent:          { start: (detail)=>{  handler.keyValueSent(detail, htmlFc)                      }},
      addAmountCredited:     { start: (detail)=>{  handler.addAmountCredited(detail, htmlFc)                 }},
      addAmount:             { start: (detail)=>{  handler.addAmount(detail, htmlFc)                         }},
      

}/**/



//function to send
function editDialog(){
		dialog.start({ act:"show", id:"saveChanges", entity:'customercredit' } )
}

function deleteDialog(detail){
		dialog.start({ act:"show",  dest:'customercredit', id:"deleteElem", entity:'customercredit', dbid: detail.dbid } )
}

function dtCall(act, result){ 
		customercreditDt.start({act:act, row: result})
}

function saveFromDialog(detail, htmlFc){
      if (handler.validated(detail,htmlFc)){
            fullcontEntity.saveFromDialog(detail, htmlFc)
      }
}

function addOne(detail, htmlFc){
      if (handler.validated(detail,htmlFc)){
            fullcontEntity.addOne(detail, htmlFc) 
      }
}

function update(detail, htmlFc){
      if (handler.validated(detail,htmlFc)){
            fullcontEntity.update(detail, htmlFc) 
      }
}

function deleteFromDialog(detail, htmlFc){

      fullcontEntity.deleteFromDialog(detail, htmlFc) 
      setTimeout(()=>{
            customercreditDt.start({"dest":"customercredit", "elem":"dt", "act":"select", "entity":"customercredit"})  
      },900)  
                   
}

//Function to set default values to fullcont fields when creating a record is pressed
function setDefaultValue(htmlFc){

      let sale_date  = htmlFc.fullcontHTML.querySelector('#customercredit_form_date input');
      sale_date.value = timeDate.convertDateToInput();


      htmlFc.formCopy.forEach(element => {

            if (element.name == "date") {
                  element.value=sale_date.value;
            }
      });
}


